import { IBatch } from './IPremix'
import { IStockCard } from './IStockCard'

export interface IProductionBatch {
  productionBatchId: number
  batchNumber: string
  productionId: number
  quantity: number | string
  confirmedQuantity: number | string
  latestStock: number | string
  confirmedAt: string
  createdAt: string
  createdBy: string
  confirmedBy: string
  fillingAmount: number | string
  packagingAmount: number | string
  fillingUnit: string
  lastModifiedEmployeeId: string
  batch: IBatch
}
export interface IProduction {
  [key: string]: any
  type: string
  productionId: number | null
  salesOrderId: number | null
  brandId: string
  productId: number | null
  premixId: string
  premixName: string
  premixStock: number | null
  packagingId: string
  packagingName: string
  packagingStock: number | null
  productionDisplayId: string
  premixQuantity: number | string | null
  productQuantity: number | string | null
  packagingQuantity: number | string | null
  packagingFillingAmount: number | string | null
  packagingFillingUnit: string
  salesOrderNumber: string | null
  salesOrderDisplayId: string | null
  otDisplayId: string | null
  isComplete: boolean
  notes: string
  createdAt: string
  createdBy: string
  lastModifiedEmployeeId: string
  stockCards: IStockCard[]
  batches: IProductionBatch[]
}

export class Production implements IProduction {
  [key: string]: any
  type: string
  productionId: number | null
  salesOrderId: number | null
  brandId: string
  productId: number | null
  premixId: string
  premixName: string
  premixStock: number | null
  packagingId: string
  packagingName: string
  packagingStock: number | null
  productionDisplayId: string
  premixQuantity: number | string | null
  productQuantity: number | string | null
  packagingQuantity: number | string | null
  packagingFillingAmount: number | string | null
  packagingFillingUnit: string
  salesOrderNumber: string | null
  salesOrderDisplayId: string | null
  otDisplayId: string | null
  isComplete: boolean
  notes: string
  createdAt: string
  createdBy: string
  lastModifiedEmployeeId: string
  stockCards: IStockCard[]
  batches: IProductionBatch[]

  constructor({
    type,
    productionId,
    salesOrderId,
    brandId,
    productId,
    premixQuantity,
    packagingQuantity,
    premixId,
    premixStock,
    premixName,
    packagingId,
    packagingName,
    packagingStock,
    packagingFillingAmount,
    packagingFillingUnit,
    productionDisplayId,
    productQuantity,
    isComplete,
    salesOrderNumber,
    salesOrderDisplayId,
    otDisplayId,
    notes,
    createdAt,
    createdBy,
    lastModifiedEmployeeId,
    stockCards,
    batches,
  }: Partial<IProduction> = {}) {
    this.type = type || ''
    this.productionId = productionId ?? null
    this.salesOrderId = salesOrderId ?? null
    this.premixId = premixId || ''
    this.brandId = brandId ?? ''
    this.productId = productId ?? null
    this.premixName = premixName || ''
    this.packagingId = packagingId || ''
    this.packagingName = packagingName || ''
    this.premixStock = premixStock ?? null
    this.packagingStock = packagingStock ?? null
    this.productionDisplayId = productionDisplayId || ''
    this.premixQuantity = premixQuantity ?? null
    this.packagingQuantity = packagingQuantity ?? null
    this.productQuantity = productQuantity ?? null
    this.isComplete = isComplete || false
    this.packagingFillingAmount = packagingFillingAmount ?? null
    this.packagingFillingUnit = packagingFillingUnit || 'g'
    this.salesOrderNumber = salesOrderNumber || ''
    this.salesOrderDisplayId = salesOrderDisplayId || ''
    this.otDisplayId = otDisplayId || ''
    this.notes = notes || ''
    this.createdBy = createdBy || ''
    this.createdAt = createdAt || ''
    this.lastModifiedEmployeeId = lastModifiedEmployeeId || ''
    this.stockCards = stockCards || []
    this.batches = batches || []
  }
}

export interface IPbos {
  pbosId: number | null
  pbosDisplayId: string
  productionId: number | null
  premixId: string
  batchNumber: string
  quantity: number | string | null
}

export class Pbos implements IPbos {
  pbosId: number | null
  pbosDisplayId: string
  productionId: number | null
  premixId: string
  batchNumber: string
  quantity: number | string | null

  constructor({
    pbosId,
    pbosDisplayId,
    productionId,
    premixId,
    batchNumber,
    quantity,
  }: Partial<IPbos> = {}) {
    this.pbosId = pbosId ?? null
    this.pbosDisplayId = pbosDisplayId || ''
    this.productionId = productionId ?? null
    this.premixId = premixId || ''
    this.batchNumber = batchNumber || ''
    this.quantity = quantity ?? null
  }
}

export enum ProductionSourceOrDestination {
  rndIn = 'RnD Masuk',
  rndOut = 'RnD Keluar',
  gudangFilling = 'Gudang Filling',
}
